module.exports = __webpack_public_path__ + "img/visa.1bda7652.svg";